<template>
  <div id="AvailabilityFounds">
    <custom-contact-info-modal
      ref="contactInfoModalRef"
      @cancel="cancelModal"
      @save="saveModal"
    />
    <div class="row justify-content-between align-items-end">
      <div class="col">
        <TitleBreadcrumb :page="page" />
      </div>
      <div>
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="outline-success m-2"
          @click="goBack"
        >
          Regresar
        </ActionButton>
        <ActionButton
          v-if="!isCompleted"
          i="fas fa-arrow-circle-right"
          variant="success m-2"
          @click="onCheckBoxesClicked"
        >
          Continuar
        </ActionButton>
        <!--"showModal = true"-->
      </div>
    </div>
    <div class="dropdown-divider pb-2 w-100" />
    <SectionTitle
      content="Validación de servicios disponibles para estudiantes ubicados en escuelas privadas por sus padres"
    />
    <div class="dropdown-divider pb-2 w-100" />
    <div class="regular mx-3" v-html="narrativeText" />
    <div class="row justifyleft">
      <div class="col selfCenter">
        Para acceder al documento, puede dar un clic aquí:
      </div>
      <div class="col">
        <ActionButton
          i="fas fa-file-download"
          variant="outline-success"
          @click="download"
        >
          Descargar
        </ActionButton>
      </div>
      <div class="col" />
    </div>
    <div v-if="!isCompleted" class="row justify-content-end">
      <div class="col-4 tar">
        <div class="btn bg-orange text-white px-4 regular">
          Turno actual: {{ nroTurno }}
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <vue-good-table
          mode="remote"
          style-class="table vgt-availabilityFounds striped table-hover"
          :rows="tableConfig.rows"
          :columns="tableColumns"
          :sort-options="{
            enabled: false,
          }"
          :pagination-options="{
            enabled: true,
          }"
        >
          <div slot="emptystate">
            <div class="text-center text-gray">
              Sin datos.
            </div>
          </div>
          <template slot="table-row" slot-scope="props">
            <!-- <span v-if="(props.column.label == 'Observaciones' && props.row.observation != '')"> -->
            <span
              v-if="
                props.column.label == 'Observaciones' &&
                  props.row.availabilityFunds == 'No' &&
                  !props.row.isServiceActived
              "
            >
              <div class="custom-control custom-checkbox">
                <input
                  :id="`chkObservation-${props.index}`"
                  type="checkbox"
                  :disabled="isCompleted"
                  :checked="isCompleted"
                  class="custom-control-input"
                  @click="verifyCheckbox(props.row)"
                />
                <label
                  class="custom-control-label font regular"
                  :for="`chkObservation-${props.index}`"
                >
                  Notificado
                </label>
              </div>
            </span>
            <span
              v-else-if="props.column.label == '' && props.row.action != ''"
            >
              <ActionButton
                v-if="props.row.availabilityFunds == 'No'"
                i="fas fa-print"
                variant="outline-success"
                @click="downloadnotfundsavailable(props.row)"
              >
                Imprimir
              </ActionButton>
            </span>
            <span v-else-if="props.column.label == 'Disponibilidad Fondos'">
              <div
                :class="getClassAvailabilityFunds(props.row.availabilityFunds)"
              >
                {{ props.row.availabilityFunds }}
              </div>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <template slot="pagination-bottom" slot-scope="props">
            <customPager
              ref="historyPager"
              :per-page="tableConfig.serverParams.perPage"
              :total="props.total"
              :page-changed="props.pageChanged"
              :per-page-changed="props.perPageChanged"
            />
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import ActionButton from '@/components/common/ActionButton';
import { SectionTitle } from '@/components/pei/shared';
import alert from '@/mixin/alert.mixin';
import PeiStatus from '@/utils/constants/pei/peiStatus';
import CustomContactInfoModal from '@/components/common/CustomContactInfoModal';
import StudentService from '@/services/student';
import generalService from '@/services/pei/general';
import reportService from '@/services/report';

export default {
  name: 'AvailabilityFunds',
  mixins: [alert],
  components: {
    TitleBreadcrumb,
    ActionButton,
    SectionTitle,
    CustomContactInfoModal,
  },
  data: () => ({
    narrativeText: '',
    page: {
      icon: 'fas fa-user-edit',
      title: 'Disponibilidad de Fondos',
      routes: [
        'Inicio',
        'PEI',
        'Análisis de Alternativa de Ubicación y Servicios',
        'Disponibilidad de Fondos',
      ],
    },
    nroTurno: 0,
    showModal: false,
    tableConfig: {
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10,
      },
      rows: [],
    },
  }),

  mounted() {
    this.loadValidationMessages();
    this.getTurnNumber();
    this.getFundsAvailableForService();
  },
  computed: {
    peiId() {
      return this.$store.state.peiSelected;
    },
    selectedPei() {
      return this.$store.state.pei;
    },
    tableColumns() {
      let columns = [
        {
          label: 'Servicios Relacionados',
          field: 'relationServices',
        },
        {
          label: 'Disponibilidad Fondos',
          field: 'availabilityFunds',
        },
        {
          label: 'Observaciones',
          field: 'observation',
        },
        {
          label: 'Turno Asignado',
          field: 'assignedTurn',
          selected: true,
        },
        {
          label: '',
          field: 'action',
          selected: true,
        },
      ];

      return columns.filter(
        (h) => h.selected == this.isCompleted || h.selected == null
      );
    },
    newPeiStatus() {
      let hasActiveService = this.tableConfig.rows.some(
        (element) => element.availabilityFunds == 'Servicio Activo'
      );

      if (hasActiveService) return PeiStatus.PartialSignedPendingFunds;

      return PeiStatus.CompletedWithPendingFunds;
    },
    isCompleted() {
      return (
        this.selectedPei.peiStatusCode == PeiStatus.CompletedWithPendingFunds ||
        this.selectedPei.peiStatusCode == PeiStatus.PartialSignedPendingFunds
      );
    },
    studentSie() {
      return this.$store.state.$_student.selectedStudent.studentId;
    },
  },
  methods: {
    async onCheckBoxesClicked() {
      let hasElementClicked = this.tableConfig.rows.some(
        (element) => element.clicked && element.availabilityFunds == 'No'
      );
      if (!hasElementClicked) {
        alert.methods.ShowAlertModal(
          'Atención',
          'Favor marcar que los servicios sin disponibilidad de fondos fueron notificados.',
          'error',
          ''
        );
      } else {
        await this.$refs.contactInfoModalRef.open();
      }
    },
    verifyCheckbox(params) {
      this.tableConfig.rows.find(
        (e) => e.objectId == params.objectId
      ).clicked = !params.clicked;
    },
    getFundsAvailableForService() {
      let self = this;
      let promise = this.$ApiGet(
        '/api/pei/getavailablefundsforservices?peiId=' +
          this.$store.state.peiSelected
      );
      promise.then((res) => {
        let index = 0;
        res.data.forEach(function(serviceFund) {
          let service = {
            objectId: index,
            relationServices: serviceFund.disciplineTypeName,
            availabilityFunds: serviceFund.isActiveInSAEE
              ? 'Servicio Activo'
              : 'No',
            observation: '', //serviceFund.accepted ? 'Notificado' : '',
            assignedTurn: serviceFund.turnNumber,
            action: 'Imprimir',
            clicked: serviceFund.isActiveInSAEE,
            isServiceActived: serviceFund.isActiveInSAEE,
            disciplineTypeCd: serviceFund.disciplineTypeCd,
          };
          self.tableConfig.rows.push(service);
          index++;
        });
      });
    },
    getTurnNumber() {
      let promise = this.$ApiGet(
        '/api/pei/getturnnumber?peiId=' + this.$store.state.peiSelected
      );
      promise.then((res) => {
        this.nroTurno = res.data;
      });
    },
    loadValidationMessages() {
      let promise = this.$ApiGet('/api/validationsmessages?messageCodes=9090');
      promise.then((res) => {
        this.narrativeText = res.data.find((x) => x.id === '9090').name;
      });
    },
    goBack() {
      this.$router.push('/pei/detail/');
    },
    async download() {
      this.$ApiGet(
        '/api/affirmativeletters/document/' +
          this.$store.state.pei.academicYearId
      )
        .then((res) => {
          res.data;
          generalService.documentDownloadReport(
            res.data.content,
            res.data.filename
          );
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    cancelModal() {
      this.showModal = false;
    },
    async saveModal(params) {
      let contactInfo = {
        contactName: params.contactname,
        contacteMail: params.contactemail,
        emailSuppliedFlag: params.emailsuppliedflag,
        contactTelephone: params.contacttelephone,
        contactTelephoneProviderCode: params.contacttelephoneprovidercode,
        regStudentId: params.regstudentid,
        contactRelation: params.contactrelation,
        receiveMessageTextFlag: params.receiveMessageTextFlag,
      };
      await StudentService.updateStudentContactInformation(contactInfo);
      this.$ApiPost(
        'api/pei/' + this.peiId + '/signpeifromavailablefundsforservices'
      )
        .then(() => {
          this.ShowToast(
            'Verificar información de contacto',
            'Guardado Exitosamente!',
            'success'
          );

          this.showModal = false;
          this.$store.dispatch('setSelectedPeiStatus', this.newPeiStatus);
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    getClassAvailabilityFunds(value) {
      let className = '';
      switch (value) {
        case 'Servicio Activo':
          className = 'badge badges badge-signed';
          break;
        case 'No':
          className = 'badge badges badge-erase';
          break;
      }
      return className;
    },
    async downloadnotfundsavailable(row) {
      let self = this;
      await reportService
        .downloadnotfundsavailable({
          peiId: this.peiId,
          disciplineTypeCd: row.disciplineTypeCd,
          assignedTurn: row.assignedTurn,
        })
        .catch((err) => {
          self.ShowToast('Error', err.message, 'error');
        });
    },
  },
};
</script>

<style scoped>
#AvailabilityFounds >>> td,
#AvailabilityFounds >>> tr,
#AvailabilityFounds >>> th {
  text-align: center;
}

#AvailabilityFounds >>> .vgt-availabilityFounds tbody {
  background: rgb(225, 228, 224);
  background: linear-gradient(
    180deg,
    rgba(225, 228, 224, 1) 0%,
    rgba(250, 251, 251, 1) 8%
  );
}

#AvailabilityFounds >>> .vgt-availabilityFounds thead th {
  border-top: none;
  font-weight: bold;
}

#AvailabilityFounds >>> .vgt-availabilityFounds td,
#AvailabilityFounds >>> .vgt-availabilityFounds th {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}

#AvailabilityFounds >>> .vgt-availabilityFounds th {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
}

#AvailabilityFounds >>> .vgt-availabilityFounds th:first-child {
  border-radius: 10px 0 0 0;
}

#AvailabilityFounds >>> .vgt-availabilityFounds th:last-child {
  border-radius: 0 10px 0 0;
}

#AvailabilityFounds >>> .peiStatusCell {
  text-align: center;
  padding: 5px !important;
}

#AvailabilityFounds >>> .peiActionCell {
  text-align: center;
  padding: 8px !important;
}

/*columna estatus*/
#AvailabilityFounds >>> .vgt-availabilityFounds .tablebtn {
  padding: 0px 10px;
}

.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}

.badge-signed {
  background: #a3e5b3;
}

.badge-erase {
  background: #fcc9c8;
}
.justifyleft {
  width: 59%;
  margin-left: 0px;
}
.selfCenter {
  align-self: center;
}
</style>
